import pako from 'pako'

import { NotificationController } from 'core-components/library/popup'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import settings from 'src/config/settings'

import { IFetchWelcomeFlowPartners } from './types'
import { IWelcomeFlowData } from './types'

export const INITIAL_STATE: IWelcomeFlowData = {
  PartnerFlags: [],
  Partners: [],
  RtmList: [],
  UserData: [],
  MissingAssignment: [],
}

export const fetchWelcomeFlowData = async () => {
  const serviceUrl = settings.httpsServices.partner360

  const url = `${serviceUrl}/api/v0/salesTeam/myPartnersListGzip`
  const [accessToken] = getTokens()

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({}),
    })

    const buffer = await response.arrayBuffer()
    const jsonString = pako.ungzip(buffer, { to: 'string' })
    const result = JSON.parse(jsonString) as IFetchWelcomeFlowPartners
    if (result.status !== 'success') {
      throw new Error('Fail to fetch list of partners')
    }

    return {
      ...INITIAL_STATE,
      ...result.data,
    }
  } catch (e: unknown) {
    const errorMessage = e instanceof Error ? e.message : 'Failed to fetch welcome flow data'
    NotificationController.showError({
      message: errorMessage,
    })

    return INITIAL_STATE
  }
}
